import React, { useEffect, useState } from "react";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, LineElement, PointElement } from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { getAllAnalytics } from "../services/analyticsApi";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

const Analytics = () => {
  const [analytics, setAnalytics] = useState(null);

  const fetchAnalytics = async () => {
    try {
      const res = await getAllAnalytics();
      setAnalytics(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  if (!analytics) return <div>Loading analytics...</div>;

  // Daily Revenue (Last 30 Days)
  const dailyRevenueLabels = analytics.series.dailyLast30.map(d => new Date(d.date).toLocaleDateString());
  const dailyRevenueData = analytics.series.dailyLast30.map(d => d.revenue);

  const dailyRevenueChart = {
    labels: dailyRevenueLabels,
    datasets: [
      {
        label: "Daily Revenue",
        data: dailyRevenueData,
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.2)",
        tension: 0.3,
      },
    ],
  };

  // Top Items by Revenue
  const topItemsLabels = analytics.rankings.topItemsByRevenue.map(item => item._id);
  const topItemsRevenue = analytics.rankings.topItemsByRevenue.map(item => item.totalRevenue);

  const topItemsChart = {
    labels: topItemsLabels,
    datasets: [
      {
        label: "Revenue",
        data: topItemsRevenue,
        backgroundColor: "rgba(153,102,255,0.6)",
      },
    ],
  };

  // Invoice Buckets
  const invoiceBucketLabels = analytics.distributions.invoiceBuckets.map(b => b._id.toString());
  const invoiceBucketData = analytics.distributions.invoiceBuckets.map(b => b.count);

  const invoiceBucketChart = {
    labels: invoiceBucketLabels,
    datasets: [
      {
        label: "Invoices Count",
        data: invoiceBucketData,
        backgroundColor: "rgba(255,159,64,0.6)",
      },
    ],
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Sales Analytics Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
        <div className="bg-white p-4 shadow rounded">
          <h2 className="text-xl font-semibold mb-4">Daily Revenue (Last 30 Days)</h2>
          <Line data={dailyRevenueChart} />
        </div>

        <div className="bg-white p-4 shadow rounded">
          <h2 className="text-xl font-semibold mb-4">Top Items by Revenue</h2>
          <Bar data={topItemsChart} />
        </div>

        <div className="bg-white p-4 shadow rounded">
          <h2 className="text-xl font-semibold mb-4">Invoice Buckets</h2>
          <Bar data={invoiceBucketChart} />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
